import AiAgentSettings from './Index.vue';
import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/ai-agents'),
      meta: {
        permissions: ['administrator'],
      },
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'ai_agents_settings',
          component: AiAgentSettings,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
